import { z } from 'zod'

import { apiClient } from './client'

const profileSchema = z.object({ fullName: z.string().nullable(), email: z.string() })
export type Profile = z.infer<typeof profileSchema>

export async function getProfile(): Promise<Profile> {
  return profileSchema.parse((await apiClient.get('/account/profile')).data)
}

export async function updateProfile(fullName: string): Promise<Profile> {
  return profileSchema.parse((await apiClient.put('/account/profile', { fullName })).data)
}

/** Ends every session of the user (this one included) once it succeeds. */
export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiClient.post('/account/password', { currentPassword, newPassword })
}

export async function signOutEverywhere(): Promise<void> {
  await apiClient.post('/account/sign-out-everywhere')
}
